import {createVuetify} from "vuetify";
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import { cs, en } from 'vuetify/locale'
import { connectedLocationStrategy } from '../utils/locationStrategy.js';
const defaultAccent = '#ee8025';
export default function(color, clientWidth) {
    return createVuetify({
        ssr: import.meta.env.SSR ? (clientWidth ? {clientWidth} : true) : false,
        theme: {
            options: {
                customProperties: true
            },
            defaultTheme: 'motonet',
            themes: {
                motonet: {
                    dark: false,
                    colors: {
                        'cis-accent-color': color || defaultAccent
                    }
                },
                light: {
                    colors: {
                        'cis-accent-color': color || defaultAccent
                    }
                }
            }
        },
        icons: {
            defaultSet: 'mdi',
            aliases,
            sets: {
                mdi,
            },
        },
        display: {
            thresholds: {
                xs: 0,
                sm: 586,
                md: 800,
                lg: 1023,
                xl: 1360,
            },
        },
        locale: {
            locale: 'cs',
            fallback: 'en',
            messages: { cs, en },
        },
        defaults: {
            VImg: {
                crossorigin: 'anonymous',
            },
            VMenu: {
                locationStrategy: connectedLocationStrategy
            }
        },
    });
}
